export enum GlobalInsight {
  FOOD = 'food',
  NUTRITION = 'nutrition',
  VEGETATION = 'vegetation',
  RAINFALL = 'rainfall',
  IPC = 'ipc',
}
